var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notice_content"},[_c('h3',[_vm._v(_vm._s(_vm.contents.title))]),_c('p',{domProps:{"innerHTML":_vm._s(_vm.contents.content)}}),_c('div',{staticClass:"time_box"},[_vm._v(_vm._s(_vm.contents.createtime))])])}
var staticRenderFns = []

export { render, staticRenderFns }